import confetti from 'canvas-confetti';

const COLORS = ['#7DF9FF', '#A78BFA', '#F472B6', '#FFFFFF'];

// Triple-burst confetti fired when a token launch completes.
// zIndex must beat Radix dialog overlays (z-50) so it renders above the SuccessModal.
export const fireLaunchConfetti = () => {
  confetti({ particleCount: 140, spread: 80, origin: { y: 0.6 }, colors: COLORS, zIndex: 9999 });
  setTimeout(() => confetti({ particleCount: 70, angle: 60, spread: 60, origin: { x: 0, y: 0.7 }, colors: COLORS, zIndex: 9999 }), 250);
  setTimeout(() => confetti({ particleCount: 70, angle: 120, spread: 60, origin: { x: 1, y: 0.7 }, colors: COLORS, zIndex: 9999 }), 450);
};
